export default "__VITE_ASSET__p43LBUq5__";